export const NOT_NECESSARY = 'NOT_NECESSARY';
export const ALLOWED = 'ALLOWED';
